export function formatNumber(n, locale = 'en-GB') {
    if (typeof n !== 'number' || !isFinite(n)) return ''
    return n.toLocaleString(locale, { maximumFractionDigits: 2 })
}

export function formatDate(value, locale = 'en-GB') {
    const d = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(d.getTime())) return ''
    return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(d)
}
